import { getFetcher } from "@/services/global";
import { useEffect } from "react";
import useSWR from "swr";
import store from "store";
import { useRouter } from "next/router";
import { useSlugs } from "@/contexts/categoryTree";
import { generateSlugs } from "@/utils/category";

export function useCategoryTree(lang, setCategoryData) {
  const { setSlugs } = useSlugs();
  const { locale } = useRouter();

  const { error, data, mutate } = useSWR(
    () => `/api/category/tree?lang=${lang}`,
    getFetcher,
    {
      // revalidateOnMount: false, // 30 minutes in milliseconds
      revalidateOnFocus: false,
      onSuccess: (res) => {
        setCategoryData(res?.data?.data);
        const slugs = generateSlugs(res?.data?.data?.children_data || []);
        setSlugs(slugs);
        store.set("categoryTreeData", {
          data: res?.data?.data,
          cacheTime: Date.now() + 30 * 60 * 1000,
          locale: lang,
        });
      },
    }
  );

  useEffect(() => {
    const cached = store.get("categoryTreeData");
    if (cached && cached.locale === locale && cached.cacheTime >= Date.now()) {
      setCategoryData(cached.data);
      return;
    }
    mutate();
  }, [lang, locale, mutate, setCategoryData]);

  return {
    data: data,
    isLoading: !error && !data,
    isError: error,
    invalidate: () => mutate(`/api/category/categorynames?lang=${lang}`),
  };
}
